import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import FlexPanel from '../FlexPanel';
import ApiService from '../../services/ApiService';
import browserHistory from '../../history';
import { handleRequestApproval } from './actions';
import { getCustomerName } from './util';
import SimpleQuoteLink from './SimpleQuoteLink';

const SalesQuoteList = ({ toolbar }) => {
  const { user } = useSelector(state => state.app);

  const { isLoading, data } = useQuery('my-quotes', async () => {
    const { data } = await ApiService.get('crm/quotes', { where: btoa(JSON.stringify({ assignedTo: user.id })) });
    return data;
  });

  return (
    <FlexPanel header="Assigned to me" toolbar={toolbar}>
      <div className="quote-list">
        {isLoading === true ? (
          <div />
        ) : (
          <table>
            <tbody>
              {data.map(quote => {
                const customer = getCustomerName(quote.Customer);
                const vehicle = `[${quote.vehicleId}] ${quote.Vehicle.Year} ${quote.Vehicle.Make || ''} ${
                  quote.Vehicle.Model || ''
                }`;

                const actions = [];

                if (quote.QuoteState.logicalName === 'OPEN') {
                  actions.push(
                    <Dropdown.Item key={String(quote.id)} onClick={() => handleRequestApproval(quote.id)}>
                      Request Approval
                    </Dropdown.Item>
                  );
                }

                return (
                  <tr key={String(quote.id)}>
                    <td width="10">
                      <i
                        className="fas fa-circle"
                        style={{ color: quote.QuoteState.color }}
                        title={quote.QuoteState.name}
                      />
                    </td>
                    <td>
                      <SimpleQuoteLink quote={quote} />
                    </td>
                    <td>
                      <DropdownButton
                        id="actions"
                        className="quote-dropdown"
                        title={<div className="quote-dropdown-label">{customer}</div>}
                        variant="link"
                        alignRight
                        size="xs"
                      >
                        <Dropdown.Item onClick={() => browserHistory.push(`/EQS5/${quote.customerId}/edit`)}>
                          Edit
                        </Dropdown.Item>
                      </DropdownButton>
                    </td>
                    <td>
                      <DropdownButton
                        id="actions"
                        className="quote-dropdown"
                        title={vehicle}
                        variant="link"
                        alignRight
                        size="xs"
                      >
                        <Dropdown.Item onClick={() => browserHistory.push(`/AVI2/${quote.vehicleId}/edit`)}>
                          Edit
                        </Dropdown.Item>
                      </DropdownButton>
                    </td>
                    <td>
                      <div className="actions text-right">
                        <DropdownButton
                          id="actions"
                          title="Actions"
                          variant="primary"
                          alignRight
                          disabled={!actions.length}
                        >
                          {actions}
                        </DropdownButton>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </FlexPanel>
  );
};

SalesQuoteList.propTypes = {
  toolbar: PropTypes.any,
};

export default SalesQuoteList;
